import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeIcon, RefreshCwIcon, ShieldIcon, ClockIcon, AwardIcon } from 'lucide-react';
import { Logo } from '../components/Logo';
export function Home() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center" data-id="element-112">
      {/* Dark Hero Section */}
      <div className="w-full bg-slate-900 flex flex-col items-center px-4 pt-12 pb-24" data-id="element-113">
        <div className="w-full max-w-6xl" data-id="element-114">
          <div className="flex justify-center mb-16" data-id="element-115">
            <Logo size="lg" variant="light" data-id="element-116" />
          </div>

          <div className="text-center mb-16" data-id="element-117">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/50 border border-slate-700 text-sm text-slate-300 mb-8" data-id="element-118">
              <span className="w-2 h-2 rounded-full bg-blue-400" data-id="element-119"></span>
              NMLS #2148818 · Licensed in 16 States
            </div>

            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-120">
              Mortgages <br data-id="element-121" />
              <span className="text-blue-400" data-id="element-122">Done Better</span>
            </h1>
            <p className="text-xl text-slate-300 max-w-2xl mx-auto mb-12" data-id="element-123">
              Expert mortgage solutions with competitive rates. Let us guide you
              through every step of the home financing process.
            </p>

            <div className="flex flex-wrap justify-center gap-6 text-left" data-id="element-124">
              <div className="flex items-center gap-3 bg-slate-800/50 px-6 py-4 rounded-xl border border-slate-700" data-id="element-125">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-blue-400 border border-slate-700" data-id="element-126">
                  <ShieldIcon className="w-5 h-5" data-id="element-127" />
                </div>
                <div data-id="element-128">
                  <div className="font-bold text-white" data-id="element-129">Trusted</div>
                  <div className="text-sm text-slate-400" data-id="element-130">Since 2021</div>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-slate-800/50 px-6 py-4 rounded-xl border border-slate-700" data-id="element-131">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-blue-400 border border-slate-700" data-id="element-132">
                  <ClockIcon className="w-5 h-5" data-id="element-133" />
                </div>
                <div data-id="element-134">
                  <div className="font-bold text-white" data-id="element-135">Avg. Close</div>
                  <div className="text-sm text-slate-400" data-id="element-136">As Fast as 11 Days*</div>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-slate-800/50 px-6 py-4 rounded-xl border border-slate-700" data-id="element-137">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-blue-400 border border-slate-700" data-id="element-138">
                  <AwardIcon className="w-5 h-5" data-id="element-139" />
                </div>
                <div data-id="element-140">
                  <div className="font-bold text-white" data-id="element-141">2,000+</div>
                  <div className="text-sm text-slate-400" data-id="element-142">Families Served</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Light Cards Section */}
      <div className="w-full max-w-6xl px-4 -mt-12 pb-16" data-id="element-143">
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-144">
          <button onClick={() => navigate('/purchase')} className="group bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-blue-600 hover:shadow-xl transition-all duration-200 text-left" data-id="element-145">
            <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors" data-id="element-146">
              <HomeIcon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors" data-id="element-147" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-148">
              Purchase Application
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-149">
              Apply for a mortgage to purchase a new home. Complete our
              streamlined application process.
            </p>
            <div className="flex items-center text-blue-600 font-medium group-hover:gap-2 transition-all" data-id="element-150">
              Start Application
              <span className="ml-2 group-hover:ml-0 transition-all" data-id="element-151">→</span>
            </div>
          </button>

          <button onClick={() => navigate('/refinance')} className="group bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-blue-600 hover:shadow-xl transition-all duration-200 text-left" data-id="element-152">
            <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors" data-id="element-153">
              <RefreshCwIcon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors" data-id="element-154" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-155">
              Refinance Application
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-156">
              Refinance your existing mortgage to get better rates or terms.
              Quick and easy process.
            </p>
            <div className="flex items-center text-blue-600 font-medium group-hover:gap-2 transition-all" data-id="element-157">
              Start Application
              <span className="ml-2 group-hover:ml-0 transition-all" data-id="element-158">→</span>
            </div>
          </button>
        </div>
      </div>
    </div>;
}